import React, { useEffect, useState } from 'react';
import { ActivityIndicator, Image, ScrollView, View, StyleSheet, FlatList, TouchableOpacity } from "react-native"
import { Text } from '../../globalComponents/NativeOverrides';
import Colors from '../../constants/Colorsv2';
import { useDispatch, useSelector } from 'react-redux';
import { player_getBulkPlayers } from '../../store/actionsv1/player';
import { OrderProps } from '../../store/types/mk_svc';
import { market_getH2HHistoryByH2HId, market_getH2HRequestsByH2HId, market_getOrdersByPlayerId } from '../../store/actionsv1/markets';
import OrderCard from '../../Componentsv1/OrderCard';
import { order_getAllOrderStatsFromOrders, order_getOrderStatsFromOrders } from '../Home/helpers/orders';
import { V1_UPDATE_CHALLENGER } from '../../store/actionsv1/types';
import { Battle } from '../../Componentsv1/Icons';


const HeadtoHeadScreen = ({ route, navigation }:any) => {
    const [ loading, setLoading ] = useState(false);
    const [ history_pulled, setHistoryPulled ] = useState(false)
    const [ market_type, setMarketType ] = useState('FOR_MONEY');
    const [ active_tab, setActiveTab ] = useState('stats');
    const [ history_orders, setHistoryOrders ] = useState<OrderProps[]>([])
    const filtered_history_orders = history_orders.filter(o => o.market_type == market_type && o.positions && o.positions[0])
    const [ header_size, setHeaderSize ] = useState({ height:0, width:0 })

    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width);
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const competitor = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == route.params?.player_id), (left, right) => left?.player_id == right?.player_id)

    //H2H requests
    const h2h_requests:OrderProps[] = useSelector((state:any) => state.player.h2h_requests.filter(o => o.h2h_id == route.params?.player_id && o.status == 'approved'), (left, right) => left.length == right.length);
    const orders_state:{updated:number, orders:OrderProps[]} = useSelector((state:any) => state.player.orders, (left, right) => left.updated == right.updated)
    const orders = orders_state.orders.filter(o => o.market_type === market_type && o.h2h_id == route.params?.player_id && o.status == 'approved');

    const dispatch = useDispatch();

    useEffect(() => {
        if(route.params?.player_id == player?.player_id){
            return navigation.navigate('SocialProfile', { player_id: route.params.player_id })
        }
    },[route.params?.player_id])

    useEffect(() => {
        if(!route.params?.player_id){ return }
        switch(active_tab){
            case 'active':
                getH2HDataFromServer(route.params.player_id)
                return
            case 'history':
                if(history_pulled){ return }
                getHistoryFromServer(route.params.player_id)
                return
            case 'stats':
                if(history_pulled){ return }
                getHistoryFromServer(route.params.player_id)
                return
            default:return
        }
    },[active_tab])


    const getHistoryFromServer = async(h2h_id:string) => {
        setLoading(true);
        if(!competitor){ await dispatch(player_getBulkPlayers([h2h_id])) }
        const orders = await market_getH2HHistoryByH2HId(h2h_id)
        setHistoryOrders(orders)
        setHistoryPulled(true)
        setLoading(false);
    }

    const getH2HDataFromServer = async(player_id:string) => {
        setLoading(true);
        if(!competitor){ await dispatch(player_getBulkPlayers([player_id])) }
        await dispatch(market_getOrdersByPlayerId(player.player_id, 0, true, 'inprogress'))
        await dispatch(market_getH2HRequestsByH2HId(player.player_id))
        setLoading(false);
    }

    const renderOrders = (data:{ item:OrderProps, index:number }) => {
        return (
            <View style={{ margin:4 }}>
                <OrderCard
                    order={data.item}
                    view_mode='edit'
                    h2h_request={true}
                />
            </View>
        )
    }

    const renderMyChallenges = (data:{ item:OrderProps, index:number }) => {
        return (
            <View style={{ margin:4 }}>
                <OrderCard
                    order={data.item}
                    view_mode='edit'
                />
            </View>
        )
    }

    const renderHistory = (data: { item: OrderProps, index:number }) => {
        return (
            <View style={{ backgroundColor:Colors.shades.white, padding:10, borderBottomWidth:1, borderColor:Colors.shades.shade600 }}>
                <OrderCard
                    order={data.item}
                    view_mode='share'
                    compact
                />
            </View>
        )
    }

    if(!player || !competitor){
        return <></>
    }

    const order_stats = order_getAllOrderStatsFromOrders(filtered_history_orders)
    const cl = market_type == 'FOR_MONEY' ? '$' : 'E'
    return (
        <View style={{ flex:1 }}>
            <ScrollView style={{ flex:1, backgroundColor:Colors.shades.white }}>
                <View nativeID='head_to_head_header' style={{ flexDirection:'row', padding:10, backgroundColor:Colors.shades.shade100 }} onLayout={(ev) => {
                    const { height, width } = ev.nativeEvent.layout;
                    setHeaderSize({ height, width })
                }}>
                    <View nativeID='me' style={{ flex:1, alignItems:'flex-end', marginRight:2, opacity:0.5 }}>
                        <Image
                            source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : require('../../assets/images/default-avatar.png')  }}
                            style={{ width: app_size.width * 0.5, height: app_size.width * 0.5}}
                            resizeMode='cover'
                        />
                    </View>
                    <View nativeID='competitor' style={{ flex:1, marginLeft:2, opacity:0.5 }}>
                        <Image
                            source={{ uri: competitor.profile_pic && competitor.profile_pic != '' ? competitor.profile_pic : require('../../assets/images/default-avatar.png')  }}
                            style={{ width: app_size.width * 0.5, height: app_size.width * 0.5 }}
                            resizeMode='cover'
                        />
                    </View>
                    <View style={{ position:'absolute', top:0, bottom:0, left:0, right:0, justifyContent:'center', alignItems:'center' }}>
                        <View style={{ backgroundColor:Colors.shades.white, borderRadius:100, padding:25, justifyContent:'center', alignItems:'center', ...style.raised }}>
                            <Text size={24} color={Colors.brand.slate} weight='semibold' textAlign='center'>VS</Text>
                        </View>
                    </View>
                    <Text 
                        style={{ 
                            position:'absolute', minWidth:100, paddingRight:30, top:(header_size.height / 2) - 30, right:(header_size.width / 2) + 15, backgroundColor:Colors.shades.white, 
                            padding:10, borderRadius:8
                        }} 
                        size={16} color={Colors.brand.midnight}
                        weight='bold' textAlign='right'>{player.username}</Text>
                    <Text 
                        style={{ 
                            position:'absolute', paddingLeft:30, minWidth:100, top:(header_size.height / 2) - 5, left:(header_size.width / 2) + 15, backgroundColor:Colors.shades.white, 
                            padding:10, borderRadius:8
                        }} 
                        size={16} color={Colors.brand.midnight}
                        weight='bold'>{competitor.username}</Text>
                </View>
                <View nativeID='challenge' style={{ padding:5, backgroundColor:Colors.shades.shade100 }}>
                    <TouchableOpacity style={{ flexDirection:'row', justifyContent:'center', alignItems:'center', backgroundColor:Colors.utility.success, padding:10, borderRadius:4 }}
                    onPress={() => {
                        dispatch({ type: V1_UPDATE_CHALLENGER, player: competitor })
                        navigation.navigate('EventStack', { screen:'Events' })
                    }}>
                        <Battle size={24} color={Colors.shades.white} />
                        <Text style={{ marginLeft:10 }} size={14} color={Colors.shades.white} weight='semibold' textAlign='center'>CHALLENGE</Text>
                    </TouchableOpacity>
                </View>
                <View style={{ flexDirection:'row', backgroundColor:Colors.shades.shade100, paddingTop:20 }}>
                    <TouchableOpacity style={{ flex:1, borderTopLeftRadius:8, padding:10, backgroundColor:market_type=='FOR_MONEY'?Colors.brand.electric:'transparent' }} onPress={() => setMarketType('FOR_MONEY')}>
                        <Text size={14} weight={market_type=='FOR_MONEY'?'bold':'regular'} color={market_type =='FOR_MONEY' ? Colors.shades.white : Colors.brand.electric} textAlign='center'>Real Money</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={{ flex:1, borderTopRightRadius:8, padding:10, backgroundColor:market_type=='FREE'?Colors.brand.cyan:Colors.shades.shade300 }} onPress={() => setMarketType('FREE')}>
                        <Text size={14} weight={market_type=='FREE'?'bold':'regular'} color={market_type =='FREE' ? Colors.shades.white : Colors.brand.cyan} textAlign='center'>Edge Coin</Text>
                    </TouchableOpacity>
                </View>
                <View nativeID='h2h_details' style={{ flex:1, backgroundColor:Colors.shades.white }}>
                    <View style={{flexDirection:'row', alignItems:'center', marginTop:20, paddingLeft:20, paddingRight:20, height:48, backgroundColor:Colors.shades.white}}>
                        <TouchableOpacity style={{ flex:1, paddingTop:14, paddingBottom:14, paddingRight:6, paddingLeft:6, borderColor:Colors.brand.midnight, borderBottomWidth:active_tab=='stats'? 1 : 0 }} onPress={() => setActiveTab('stats')}>
                            <Text size={14} weight={active_tab === 'stats' ? 'bold' : 'regular'} color={active_tab === 'stats' ? Colors.brand.midnight : Colors.brand.slate} textAlign='center'>Stats</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flex:1, paddingTop:14, paddingBottom:14, paddingRight:6, paddingLeft:6, borderColor:Colors.brand.midnight, borderBottomWidth:active_tab==='active'? 1 : 0 }} onPress={() => setActiveTab('active')}>
                            <Text size={14} weight={active_tab === 'active' ? 'bold' : 'regular'} color={active_tab === 'active' ? Colors.brand.midnight : Colors.brand.slate} textAlign='center'>Challenges</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flex:1, paddingTop:14, paddingBottom:14, paddingRight:6, paddingLeft:6, borderColor:Colors.brand.midnight, borderBottomWidth:active_tab==='history'? 1 : 0 }} onPress={() => setActiveTab('history')}>
                            <Text size={14} weight={active_tab === 'history' ? 'bold' : 'regular'} color={active_tab === 'history' ? Colors.brand.midnight : Colors.brand.slate} textAlign='center'>History</Text>
                        </TouchableOpacity>
                    </View>
                    {active_tab == 'active' ?
                    <View nativeID='h2h_bets'>
                        <FlatList
                            data={h2h_requests}
                            renderItem={renderOrders}
                        />
                        <FlatList
                            data={orders}
                            renderItem={renderMyChallenges}
                        />
                        {!loading && h2h_requests.length == 0 && orders.length == 0 ?
                        <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                            <Image
                                source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698862064/open_box_nryphw.png' }}
                                style={{ width: app_size.width * 0.7, height: app_size.width * 0.7 }}
                                resizeMode='contain'
                            />
                            <Text style={{ marginTop:5 }} size={18} weight='bold' textAlign='center'>You Have No Open Challenges</Text>
                        </View>
                        :<></>}
                    </View>
                    : active_tab == 'stats' ?
                    <View nativeID='h2h_stats' style={{ padding:10, backgroundColor:Colors.shades.white }}>
                        <View nativeID='wins' style={{ flexDirection:'row', alignItems:'center', padding:10, borderColor:Colors.shades.shade600, borderBottomWidth:1 }}>
                            <Text style={{ flex:1 }} size={24} color={Colors.brand.midnight} textAlign='center' weight='bold'>{order_stats.wins}</Text>
                            <Text size={14} color={Colors.brand.slate} textAlign='center' weight='semibold'>WINS</Text>
                            <Text style={{ flex:1}} size={24} color={Colors.brand.midnight} textAlign='center' weight='bold'>{order_stats.losses}</Text>
                        </View>
                        <View nativeID='wins' style={{ flexDirection:'row', alignItems:'center', padding:10, borderColor:Colors.shades.shade600, borderBottomWidth:1 }}>
                            <Text style={{ flex:1 }} size={24} color={Colors.brand.midnight} textAlign='center' weight='bold'>{cl}{order_stats.earnings.toFixed(2)}</Text>
                            <Text size={14} color={Colors.brand.slate} textAlign='center' weight='semibold'>EARNINGS</Text>
                            <Text style={{ flex:1}} size={24} color={Colors.brand.midnight} textAlign='center' weight='bold'>{cl}{(order_stats.earnings * -1).toFixed(2)}</Text>
                        </View>
                    </View>
                    : active_tab == 'history' ?
                    <View nativeID='h2h_history' style={{ }}>
                        <FlatList 
                            data={filtered_history_orders}
                            renderItem={renderHistory}
                        />
                        {!loading && filtered_history_orders.length == 0 ?
                        <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                            <Image
                                source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698862064/open_box_nryphw.png' }}
                                style={{ width: app_size.width * 0.7, height: app_size.width * 0.7 }}
                                resizeMode='contain'
                            />
                            <Text style={{ marginTop:5 }} size={18} weight='bold' textAlign='center'>You Have No History</Text>
                        </View>
                        :<></>}
                    </View>
                    :<></>}
                </View>
                
                {loading ?
                <ActivityIndicator size='large' color={Colors.brand.midnight} style={{ alignSelf:'center', padding:20 }}/>
                :<></>}
            </ScrollView>
        </View>
    )
}

const style = StyleSheet.create({
    raised: { shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.25, shadowRadius: 3.84, elevation: 5 }
})

export default HeadtoHeadScreen